export default __webpack_public_path__ + "static/media/vinyl_dark.c8e58b7a.png";